export default __webpack_public_path__ + "static/media/money-back@3x.991d0692.png";